<template>
	<div class="row">
		<div class="col-12 mb-1">
			<h5 v-show="!isEmpty(nomeSolicitante)" style="font-size: 1.2rem;">Olá, {{ ucWords(nomeSolicitante) }}</h5>
			Acompanhe seu atendimento
		</div>
		<h6 class="col-12 mb-0">Dados do atendimento</h6>
		<div class="col-7">
			<span class="h6 m-0">Protocolo:</span> {{ protocolo }}
		</div>
		<div class="col-5">
			<span class="h6 m-0">Data:</span> {{ data }}
		</div>
		<div class="col-12">
			<span class="h6">
				Motivo<span v-if="exibeServico">/Serviço</span>:
			</span>
			{{ motivoServico() }}
		</div>
		<div class="col-6"><span class="h6">Placa:</span> {{ placa }}</div>
		<div class="col-12 d-flex">
			<span class="h6 mb-0 me-1" style="line-height: inherit;">Modelo: </span>
			<span class="d-flex">
				{{ trucarTexto(modeloMontadora(), 0, tamanhoString) }}
				<b-tooltip click>
					<template #target>
						<button type="button" class="btn btn-default btn-sm">
							<span class="material-symbols-outlined">visibility</span>
						</button>
					</template>
					{{modeloMontadora()}}
				</b-tooltip>
			</span>
		</div>
	</div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { isEmpty, ucWords, trucarTexto } from '@/helper/funcoes.js';

const props = defineProps({
	nomeSolicitante: { type: String, default: '' },
	protocolo: { type: String, default: '' },
	data: { type: String, default: '' },
	motivo: { type: Object, default: () => ({}) },
	servicos: { type: [Object, Array], default: () => ({}) },
	placa: { type: String, default: '' },
	modelo: { type: String, default: '' },
	montadora: { type: String, default: '' },
});

const exibeServico = computed(() => Object.keys(props.servicos).length == 1);
const tamanhoString = computed(() => {
	let total = 5 * window.screen.availWidth / 100;
	if (total > 20) {
		total = 20;
	}
	return parseInt(total);
});

function motivoServico() {
	if (isEmpty(props.motivo?.descricao)) {
		return "Não informado";
	}

	let strServico = "";
	if (props.exibeServico && !isEmpty(props.servicos)) {
		strServico = " / " + props.servicos[Object.keys(props.servicos)[0]].descricao;
	}

	return ucWords(props.motivo.descricao + strServico);
}

function modeloMontadora() {
	if (!isEmpty(props.modelo) && !isEmpty(props.montadora)) {
		return ucWords(props.modelo + " / " + props.montadora);
	}

	if (!isEmpty(props.montadora)) {
		return ucWords(props.montadora);
	}

	if (!isEmpty(props.montadora)) {
		return ucWords(props.montadora);
	}

	return "Não informado";
}
</script>
